import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardBody,
  Row,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import TiktokLogo from './../../../../../assets/tiktok_logo.png';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
} from '../../../../../../helpers/AxiosAPI';
import {
  dAPI_Delete_Ingetration,
  dAPI_Delete_TikTok_Ingetration_Group,
  gAPI_Delete_TikTok_Ingetration_Group,
  putAPI_Update_OnOff,
} from '../../../../../../constants/APIs';
import { BrowserRouter as Router, NavLink } from 'react-router-dom';
import Switch from 'rc-switch';
import InstagramIntegrationList from '../InstagramIntegrationList';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { changeInstagram } from '../../../../../../redux/actions';
import { faTiktok } from '@fortawesome/free-brands-svg-icons';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
function TiktokIntegrationThumb({
  integration,
  allProperties,
  featuresUrl,
  LoadIntegrations,
}) {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [formatedProperties, setFormatedProperties] = useState('');
  const [moreProperties, setMoreProperties] = useState('');
  const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
    !integration.disabled
  );
  useEffect(() => {
    const result = integration.properties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    if (result.length > 2) {
      const filterResults = result.slice(0, 2);
      setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
      setMoreProperties(
        'and ' + (result.length - filterResults.length) + ' more'
      );
    } else {
      const filterResults = result.filter((elem) => elem !== undefined);
      setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
    }
  }, [integration, allProperties]);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
      AxiosAPI({
        method: 'delete',
        url: `${dAPI_Delete_Ingetration}/${
          integration.id
        }/?group_id=${getGroupID()}`,
      }).then((res) => {
        let updateRequest = {
          updater: 'dashboard',
        };
        AxiosAPI({
          method: 'delete',
          url: `${dAPI_Delete_TikTok_Ingetration_Group}/${integration?.channelDetails?.userId}`,
          data: updateRequest,
        })
          .then((result) => {
            toggle();
            LoadIntegrations();
          })
          .catch((err) => {
            console.log('err', err);
          });
        AxiosPublicAPI({
          method: 'delete',
          url: `https://graph.tiktok.com/v24.0/me/subscribed_apps?access_token=${integration?.channelDetails?.accessToken}`,
        })
          .then((result) => {
            toggle();
            LoadIntegrations();
          })
          .catch((err) => {
            console.log('err', err);
          });
    
    });
  };

  const handleOnOff = (onoff) => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_OnOff}/tiktok/${integration.id}/?group_id=${getGroupID()}`,
      data: { disabled: onoff },
    }).then((res) => {
      console.log('on/off');
    });
  };

  const handleSwitchChange = (value) => {
    console.log(value);
    setCheckedPrimarySmall(value);
    handleOnOff(!value);
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This action will permanently remove the integration. Are you
                  sure you want to delete the integration?
                </ModalHeader>
                <ModalBody className="d-flex justify-content-space-between">
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Go Back
                  </Button>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Confirm
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleReset = () => {    
    window.location.href = `${process.env.REACT_APP_TIKTOK_AUTHORIZATION_URL}?client_key=${process.env.REACT_APP_TIKTOK_CLIENT_ID}&redirect_uri=https://${localStorage.getItem('host_name_url')}/${process.env.REACT_APP_TIKTOK_REDIRECT_URL}&response_type=code&scope=user.info.basic&state=${integration?.id}`;
  };

  return (
    <Fragment>
      {integration ? (
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card className="d-flex flex-row" style={{ height: '215px' }}>
            <h3 className="integrationChannel">
              {/* <img src={TiktokLogo} alt="Logo" style={{ maxWidth: '30px' }} /> */}
              <FontAwesomeIcon icon={faTiktok} size="2x" />
            </h3>
            <Switch
              className="agentswitch custom-switch-primary custom-switch-small integrationremove"
              checked={checkedPrimarySmall}
              onChange={(primary) => handleSwitchChange(primary)}
            />

            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-3">
                  <NavLink
                    to={{
                      pathname: '/app/pages/tiktok-detail/' + integration.id,
                    }}
                    key={integration.id}
                  >
                    <div className="text-center">
                      <CardImg
                        top
                        src={integration?.channelDetails?.profile}
                        alt=""
                        className="img-thumbnail border-0 rounded-circle list-thumbnail"
                      />
                      <div className="mb-1">
                        {integration?.channelDetails?.name}
                      </div>
                      <div className="mb-2">
                        <b>{formatedProperties} </b>
                        <b>{moreProperties}</b>
                      </div>
                    </div>
                  </NavLink>
                  <div className="text-center mb-3">
                    {integration?.channelDetails?.userName &&
                    integration?.channelDetails?.userName !== null ? (
                      integration?.channelDetails?.userName
                    ) : (
                      <Fragment>
                        {' '}
                        <Button
                          size="xs"
                          color="danger"
                          outline
                          style={{
                            marginTop: '20px',
                            display: 'inline-block',
                          }}
                          onClick={() => handleReset()}
                        >
                          Reconnect
                        </Button>
                      </Fragment>
                    )}
                  </div>
                </Colxx>
              </Row>
            </CardBody>
            <div className="integrationdelete">
              <FontAwesomeIcon
                icon={faTrashAlt}
                style={{ color: 'var(--theme-color-1)' }}
                cursor="pointer"
                onClick={toggle}
              />
            </div>
          </Card>
        </Colxx>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}

const mapStateToProps = ({service}) => {
  const { featuresUrl } = service;
  return featuresUrl;
};

export default injectIntl(
  connect(mapStateToProps, changeInstagram)(TiktokIntegrationThumb)
);
